/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionSeasonCreate
 */
export interface CompetitionSeasonCreate {
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeasonCreate
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof CompetitionSeasonCreate
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeasonCreate
     */
    league_id: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeasonCreate
     */
    ordinal?: number | null;
}

/**
 * Check if a given object implements the CompetitionSeasonCreate interface.
 */
export function instanceOfCompetitionSeasonCreate(value: object): value is CompetitionSeasonCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('league_id' in value) || value['league_id'] === undefined) return false;
    return true;
}

export function CompetitionSeasonCreateFromJSON(json: any): CompetitionSeasonCreate {
    return CompetitionSeasonCreateFromJSONTyped(json, false);
}

export function CompetitionSeasonCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionSeasonCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'league_id': json['league_id'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
    };
}

export function CompetitionSeasonCreateToJSON(json: any): CompetitionSeasonCreate {
    return CompetitionSeasonCreateToJSONTyped(json, false);
}

export function CompetitionSeasonCreateToJSONTyped(value?: CompetitionSeasonCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'league_id': value['league_id'],
        'ordinal': value['ordinal'],
    };
}

